import { FirebaseMessaging } from '@capacitor-firebase/messaging'
import { LocalNotifications, ActionPerformed as LocalActionPerformed, Channel } from '@capacitor/local-notifications'
import { store } from '../index'
import { push } from 'connected-react-router'
import { getCurrentRoute } from '../common/Routes/RouterSelector'
import { IGlobalState } from '../Root/store/appReducer'
// import { Preferences } from '@capacitor/preferences'
import { isAndroid, isIOS } from '../common/helpers/isNative'

export const setUpPushNotifications = async () => {
  await FirebaseMessaging.removeAllListeners()

  /*const { value: oldPushToken } = await Preferences.get({ key: 'currentPushToken' })

  // TODO:
  if (oldPushToken) {
    // On success, we should be able to receive notifications
    FirebaseMessaging.addListener('tokenReceived', (event) => {
      console.log('[PN] Push registration success, token: ' + event.token)
    })
  }*/

  if (isAndroid) {
    // Create notification channel to have heads up notifications.
    await LocalNotifications.createChannel({
      id: 'challenge', // or chat ?
      name: 'Chat',
      importance: 4,
      visibility: 1,
    })
  }

  await FirebaseMessaging.addListener('notificationReceived', async (event) => {
    const notification = event.notification
    // console.log('[PN] Notification received: ' + JSON.stringify(notification))

    const data = notification?.data as any
    if (data && data['channel_type'] === 'challenge') {
      const currentRoute = getCurrentRoute(store.getState() as any as IGlobalState)
      const pathParts = currentRoute && currentRoute.pathname ? currentRoute.pathname.split('/') : []
      // Don't display chat notification when already in that chat.
      if (pathParts[3] !== 'chat' || pathParts[2] !== data['channel_id']) {
        const { title, body, subtitle } = notification
        if (title) {
          await LocalNotifications.schedule({
            notifications: [
              {
                id: Math.floor(Math.random() * 100001), //data['gcm.message_id'] ? parseInt(data['gcm.message_id']) : 1,
                title,
                subtitle: subtitle,
                body: body ? body : '',
                extra: {
                  channel_id: data['channel_id'],
                  channel_type: data['channel_type'],
                },
                // iOS
                //actionTypeId: 'stream.chat',
                threadIdentifier: data['channel_id'],
                // Android
                group: data['channel_id'],
                channelId: 'challenge',
              },
            ],
          })
        }
      }
    }
  })

  await FirebaseMessaging.addListener('notificationActionPerformed', (event) => {
    // console.log('[PN] Push action performed: ' + JSON.stringify(event))

    const notification = event.notification
    const data = notification?.data as any
    if (data && data['channel_type'] && data['channel_id']) {
      const goalId = data['channel_id']
      console.log(`Redirecting to ${goalId} chat`)
      store.dispatch(push(`/challenges/${goalId}/chat`))
    }
  })

  await LocalNotifications.addListener(
    'localNotificationActionPerformed',
    (notificationAction: LocalActionPerformed) => {
      // console.log('[LN] Local action performed: ' + JSON.stringify(notificationAction))

      if (notificationAction.actionId === 'tap') {
        if (
          notificationAction &&
          notificationAction.notification &&
          notificationAction.notification.extra &&
          notificationAction.notification.extra['channel_type'] &&
          notificationAction.notification.extra['channel_type'] === 'challenge' &&
          notificationAction.notification.extra['channel_id']
        ) {
          const goalId = notificationAction.notification.extra['channel_id']
          console.log(`Redirecting to ${goalId} chat`)
          store.dispatch(push(`/challenges/${goalId}/chat`))
        }
      }
    },
  )
}
